// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationMobilePayPath = 'M39.36 7V0C22.542 0 8.86 13.682 8.86 30.5h7C15.86 17.542 26.402 7 39.36 7zm42.26 76.605c-.636 6.401-4.02 9.385-10.644 9.385L62.904 93C54.964 84.065 52.703 76.206 52.074 72h1.81c1.62 0 3.134.79 4.06 2.117a20.205 20.205 0 007.77 7.047l.148.072c3.179 1.444 6.938.032 8.384-3.15a6.319 6.319 0 00.564-2.597V60.5h.05v-3.934l3.715 2.133a6.255 6.255 0 013.146 5.484l-.1 19.421zM39.36 83a3.505 3.505 0 01-3.5-3.5v-49c0-1.93 1.57-3.5 3.5-3.5h4.263l3.817 5h8.84l3.817-5h4.263c1.93 0 3.5 1.57 3.5 3.5v13.972l-.05-.029v29.862a13.195 13.195 0 01-4-4.009l-.061-.093A11.999 11.999 0 0053.859 65h-8.74l-.248 3.231c-.03.382-.404 6.34 3.259 14.77h-8.77zm42.694-30.374l-7.194-4.133V30.5c0-5.79-4.71-10.5-10.5-10.5h-25c-5.79 0-10.5 4.71-10.5 10.5v49c0 5.79 4.71 10.5 10.5 10.5h12.509c1.81 2.84 4.079 5.83 6.933 8.888L59.84 100l11.139-.01c10.27 0 16.694-5.791 17.625-15.89l.116-19.871a13.25 13.25 0 00-6.667-11.605zM39.36 10v7c-7.444 0-13.5 6.056-13.5 13.5h-7c0-11.304 9.196-20.5 20.5-20.5z';
var IllustrationMobilePay = baseIllustration('IllustrationMobilePay', {
  getPath: () => IllustrationMobilePayPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationMobilePay;
//# sourceMappingURL=index.js.map